import axios from "axios";
import Noty from "noty";
import moment from "moment";
import "moment-timezone";
import WebPushService from "./WebPushService";
import i18n from "../i18n";

var http = null;
var baseURL = null;
var subscription = null;
var timer = null;
var user = null;
var time = 30;
var config = {};
var lang_code = "en";
var short_date_format = "";
var short_time_format = "";
var timeZone = "";
var long_time_format = "";
var long_date_format = "";
var lastActiveTime = new Date().getTime();

class WebService {
  constructor({}) {
    baseURL = process.env.BASE_URL;
    http = axios.create({
      baseURL: process.env.BASE_URL
    });
    this.getConfig();
    this.setSessionTime();
    var $this = this;
    document.addEventListener("mousemove", function() {
      $this.lastActiveTime = new Date().getTime();
    });
  }

  getAPI({ _action, _body, _buttonId, _hide_loader }) {
    if (_action.indexOf("notification/count") == -1) {
      this.setTime();
    }

    let params = new URLSearchParams();
    for (let key in _body) {
      params.set(key, _body[key]);
    }

    if (this.addLoader(_buttonId, _hide_loader)) {
      return;
    }

    return http
      .get(_action, {
        params: params,
        headers: this.getHeader()
      })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader);
        return response.data;
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader);
        return this._errorHandler(e);
      });
  }

  getAPIBlob({ _action, _body, _buttonId, _hide_loader }) {
    if (_action.indexOf('notification/count') == -1) {
      this.setTime();
    }

    let params = new URLSearchParams()
    for (let key in _body) {
      params.set(key, _body[key])
    }

    if (this.addLoader(_buttonId, _hide_loader)) {
      return
    }

    return http
      .get(_action, {
          params: params,
          headers: this.getHeader(),
          responseType:'blob'
      })
      .then(response => {
          this.removeLoader(_buttonId, _hide_loader)
          return response.data
      })
      .catch(e => {
          this.removeLoader(_buttonId, _hide_loader)
          return this._errorHandler(e)
      })
  }

  postAPI({ _action, _body, _buttonId, _hide_loader, _hide_error }) {
    this.setTime();
    if (this.addLoader(_buttonId, _hide_loader)) {
      return;
    }

    return http
      .post(_action, JSON.stringify(_body), { headers: this.getHeader() })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader);
        return response.data;
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader);
        return this._errorHandler(e, _hide_error);
      });
  }

  putAPI({ _action, _body, _buttonId, _hide_loader }) {
    this.setTime();
    if (this.addLoader(_buttonId, _hide_loader)) {
      return;
    }
    return http
      .put(_action, JSON.stringify(_body), { headers: this.getHeader() })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader);
        return response.data;
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader);
        return this._errorHandler(e);
      });
  }

  deleteAPI({ _action, _buttonId, _hide_loader }) {
    this.setTime();
    if (this.addLoader(_buttonId, _hide_loader)) {
      return;
    }
    return http
      .delete(_action, { headers: this.getHeader() })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader);
        return response.data;
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader);
        return this._errorHandler(e);
      });
  }

  uploadImageAPI({ _action, _file, _key, _body, _buttonId, _hide_loader }) {
    this.setTime();
    if (!_key) {
      _key = "file";
    }
    if (this.addLoader(_buttonId, _hide_loader)) {
      return;
    }
    let formData = new FormData();
    formData.append(_key, _file);
    for (let key in _body) {
      formData.append(key, _body[key]);
    }

    return http
      .post(_action, formData, { headers: this.addHeaderForMultipart() })
      .then(response => {
        this.removeLoader(_buttonId, _hide_loader);
        return response.data;
      })
      .catch(e => {
        this.removeLoader(_buttonId, _hide_loader);
        return this._errorHandler(e);
      });
  }

  _errorHandler(error, _hide_error) {
    if (error.response != null) {
      error = error.response;
    }
    var errorMessage;
    if (!error || !error.status) {
      errorMessage = "No Internet Connection";
    } else if (error.status === 401) {
      errorMessage =
        (error && error.data && error.data.message) || "Please try again";
      this.logout();
    } else if (error.status === 500) {
      errorMessage = "Service is unavailable, please retry again later";
    } else if (error.status === 410) {
      errorMessage =
        (error && error.data && error.data.message) || "Please try again";
    } else if (error.status === 402) {
      _hide_error = true;
    } else {
      errorMessage =
        (error && error.data && error.data.message) || "Please try again";
    }

    if (!_hide_error) {
      new Noty({
        type: "error",
        text: errorMessage,
        timeout: 4500
      }).show();
    }
    throw error;
  }

  setTime() {
    this.lastActiveTime = new Date().getTime();
  }

  logout() {
    WebPushService.unRegisterToken();
    localStorage.clear();
    window.location.href = "/logout";
  }

  getHeader() {
    var headers = this.getHeaders();
    headers["Content-Type"] = "application/json";
    return headers;
  }

  addHeaderForMultipart() {
    return this.getHeaders();
  }

  getHeaders(isSetTime) {
    var headers = {};
    headers["x-version"] = "1.0";
    headers["platform"] = "desktop";
    headers["x-localization"] = localStorage.getItem("language")
      ? localStorage.getItem("language")
      : lang_code;
    if (process.env.IS_ADMIN) {
      headers["x-employer"] = "N";
    } else {
      headers["x-employer"] = "Y";
    }

    if (localStorage.getItem("companyId")) {
      headers["company-id"] = localStorage.getItem("companyId");
    } else {
      headers["company-id"] = 1;
    }

    if (localStorage.getItem("token")) {
      headers["Authorization"] = "Bearer " + localStorage.getItem("token");
      headers["x-api-token"] = localStorage.getItem("session");
    }

    return headers;
  }

  addLoader(id, _hide_loader) {
    if (id && !_hide_loader) {
      var button = document.getElementById(id);
      if (button.disabled) {
        return true;
      }

      button.disabled = true;
      var img = document.createElement("img");
      img.width = "25";
      img.height = "25";
      img.src = "/static/images/btn-loader.gif";
      button.prepend(img);
      return false;
    }
  }

  getCategoryList() {
    return this.getAPI({
      _action: "/service/categories"
    })
      .then(res => {
        return res.list;
      })
      .catch(e => {});
  }
  getSubCategoryList(id) {
    return this.getAPI({
      _action: "/service/categories/" + id
    })
      .then(res => {
        return res.list;
      })
      .catch(e => {});
  }

  getSubscription() {
    return this.getAPI({
      _action: "/store/subscription/active"
    })
      .then(res => {
        this.subscription = res;
        return res;
      })
      .catch(e => {});
  }

  getBaseUrl() {
    return baseURL;
  }

  getServerUrl() {
    return process.env.APP_URL;
  }

  removeLoader(id, _hide_loader) {
    if (id && !_hide_loader) {
      var button = document.getElementById(id);
      button.disabled = false;
      button.removeChild(button.childNodes[0]);
    }
  }

  getLocalDate(date) {
    if (!date) {
      return "";
    }

    if (this.config && this.config.long_date_format) {
      date = moment(date, "YYYY-MM-DD").format(this.config.long_date_format);
    }

    return date;
  }

  getDateFromat() {
    if (this.config && this.config.long_date_format) {
      return this.config.long_date_format;
    }

    return "DD/MM/YYYY";
  }

  updateConfig(config) {
    this.config = config;
  }

  getServerDate(date) {
    if (!date) {
      return "";
    }
    if (this.config && this.config.long_date_format) {
      date = moment(date, this.config.long_date_format).format("YYYY-MM-DD");
    }
    return date;
  }

  getConfig() {
    this.getAPI({
      _action: "base-config"
    })
      .then(res => {
        this.config = res.result;
        if (res.result.session_expiry) {
          this.time = res.result.session_expiry;
        }
        if (res.result.lang_code && !localStorage.getItem("token")) {
          i18n.locale = res.result.lang_code;
          lang_code = res.result.lang_code;
          localStorage.setItem("language", res.result.lang_code);
        }
      })
      .catch(e => {});
  }

  setSessionTime() {
    var $this = this;
    if (!this.timer)
      this.timer = setInterval(() => {
        if (localStorage.getItem("token") && $this.lastActiveTime) {
          if (
            (new Date().getTime() - $this.lastActiveTime) / 60000 >
            $this.time
          ) {
            $this.logout();
          }
        }
      }, 1000 * 10);
  }
  getFormatingPrice(price) {
    if (!price && price != 0) {
      return "";
    }

    price = parseFloat(price).toFixed(2);
    price = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    if (!this.config) {
      this.config = {};
    }

    if (!this.config.currency) {
      this.config.currency = {};
    }

    if (!this.config.currency.symbol) {
      this.config.currency.symbol = "$";
    }

    if (this.config.currency.placement == "PRE") {
      return this.config.currency.symbol + " " + price;
    } else {
      return price + " " + this.config.currency.symbol;
    }
  }

  getFormatingDateTime(date) {
    if (!date) {
      return "";
    }

    if (!this.config) {
      this.config = {};
    }

    if (this.config.long_date_format && this.config.long_time_format) {
      date = moment
        .utc(date, "YYYY-MM-DD HH:mm:ss")
        .local()
        .format(
          this.config.long_date_format + " " + this.config.long_time_format
        );
    }
    return date;
  }

  allowDecimalValue(e) {
    let keyCode = e.keyCode ? e.keyCode : e.which;
    if (
      (keyCode < 48 || keyCode > 57) &&
      (keyCode !== 46 || e.target.value.indexOf(".") != -1)
    ) {
      e.preventDefault();
      return false;
    }

    // restrict to 2 decimal places
    if (
      e.target.value != null &&
      e.target.value.indexOf(".") > -1 &&
      e.target.value.split(".")[1].length > 1
    ) {
      e.preventDefault();
      return false;
    }

    return true;
  }

  checkMinAndMax(e) {
    if (
      e.keyCode != 37 &&
      e.keyCode != 8 &&
      e.keyCode != 39 &&
      e.keyCode != 46
    ) {
      if (e.target.value && parseFloat(e.target.value + e.key) > 100.0) {
        e.preventDefault();
        return false;
      }

      if (
        e.target.value.indexOf(".") != -1 &&
        e.target.selectionStart <= e.target.value.indexOf(".")
      ) {
        var temp = e.target.value.split(".");
        console.log(parseFloat(temp[0] + e.key + "." + temp[1]));
        if (
          e.target.value &&
          parseFloat(temp[0] + e.key + "." + temp[1]) > 100.0
        ) {
          e.preventDefault();
          return false;
        }
      }
    }
  }
  disableEditField() {
    if (access && access.can_read == 1) {
      return false;
    }
    if (access && access.can_update == 1) {
      return false;
    }
    if (
      access &&
      access.can_read == 1 &&
      !access.can_update &&
      !access.can_create
    ) {
      return true;
    }
  }
  disableEditField(access) {
    if (
      access &&
      access.can_read == 1 &&
      !access.can_update &&
      !access.can_create
    ) {
      disabled = true;
    } else {
      disabled = false;
    }
  }

  getFormatingShortDate(date) {
    if (!date) {
      return "";
    }
    if (short_date_format && short_date_format) {
      date = moment
        .utc(date, "YYYY-MM-DD")
        .utcOffset(timeZone.replace("UTC", ""))
        .format(short_date_format + " " + short_time_format);
    }
    return date;
  }



  getFormatingShortDateTime(date) {
    if (!date) {
      return "";
    }
    if (short_date_format && short_date_format) {
      if (short_time_format == "hh:mm A") {
        this.setShortTime("hh:mm:SS A");
      }
      date = moment
        .utc(date, "YYYY-MM-DD h:mm:ss a")
        .utcOffset(timeZone.replace("UTC", ""))
        .format(short_date_format + " " + short_time_format);
    }
    return date;
  }

  getFormatingShortDateTimeForBI(date) {
    if (!date) {
      return "";
    }

    if (short_date_format && short_time_format) {
      date = moment
        .utc(date, "YYYY-MM-DD HH:mm:ss")
        .format(short_date_format + " " + short_time_format);
    }
    return date;
  }

  getFormatingDate(date) {
    if (!date) {
      return "";
    }

    if (!this.config) {
      this.config = {};
    }

    if (this.config.long_date_format) {
      date = moment
        .utc(date, "YYYY-MM-DD")
        .local()
        .format(this.config.long_date_format);
    }

    return date;
  }
  getFormatingShortDate(date) {
    if (!date) {
      return "";
    }
    if (short_date_format) {
      date = moment
        .utc(date, "YYYY-MM-DD")
        .local()
        .format(short_date_format);
    }

    return date;
  }

  setTimeZone(zone) {
    timeZone = zone;
  }

  setShortDate(date) {
    short_date_format = date;
  }
  setShortTime(time) {
    short_time_format = time;
  }
  setLongTime(time) {
    long_time_format = time;
  }
  setShortTime(time) {
    short_time_format = time;
  }
  getDateTime() {
    return short_date_format;
  }
  // setLongDate(date) {
  //     long_date_format = date
  // }
}

export default new WebService({});



// WEBPACK FOOTER //
// ./src/services/Webservice.js